import { ContentCluster } from '@app/components/base/content-structure/ContentCluster';
import { Panel } from '@app/components/base/content-structure/Panel';
import { MessageDescriptor } from 'react-intl';
import { NotificationWorkflow } from '../workflows';
import { NotificationPreferencesRow } from './NotificationPreferencesRow';
import { NotificationPreferencesValues } from './notification-preferences-types';

export type NotificationPreferencesCategorySectionProps = {
  title: MessageDescriptor;
  workflows: readonly NotificationWorkflow[];
  values: NotificationPreferencesValues;
  disabled?: boolean;
  /** When false, skips the top hairline (use for the first category). */
  divider?: boolean;
  onChange: (next: NotificationPreferencesValues) => void;
};

/**
 * Preferences section: ContentCluster category label + headerless Panel of workflow rows.
 */
export function NotificationPreferencesCategorySection({
  title,
  workflows,
  values,
  disabled = false,
  divider = true,
  onChange,
}: NotificationPreferencesCategorySectionProps) {
  return (
    <ContentCluster message={title} divider={divider}>
      <Panel>
        {workflows.map((workflow) => (
          <NotificationPreferencesRow
            key={workflow.key}
            title={workflow.preference.title}
            description={workflow.preference.description}
            channels={workflow.channels}
            value={values[workflow.key] ?? {}}
            disabled={disabled}
            onChange={(next) => onChange({ ...values, [workflow.key]: next })}
          />
        ))}
      </Panel>
    </ContentCluster>
  );
}
